// context/ScrollRestoreContext/index.js
//
// Хэрэглэх:
//   1. _app.js-д const pendingRestoreRef = useRef(null)
//      useScrollRestoration(pendingRestoreRef) дуудна
//      <ScrollRestoreProvider onReadyRef={pendingRestoreRef}>...</ScrollRestoreProvider>
//
//   2. Data fetch дуусмагц хуудас дотор notifyScrollReady() дуудна
//
// Жишээ хуудсан дотор:
//   import { useScrollRestore } from 'context/ScrollRestoreContext';
//   const { notifyScrollReady } = useScrollRestore();
//   useEffect(() => {
//     (async () => {
//       const res = await getNewsList(...);
//       setNews(res.data);
//       notifyScrollReady(); // ← data бэлэн болсны дараа
//     })();
//   }, []);

import { createContext, useContext, useCallback } from 'react';

const ScrollRestoreContext = createContext({ notifyScrollReady: () => {} });

export const useScrollRestore = () => useContext(ScrollRestoreContext);

// _app.js-д ашиглана — useScrollRestoration hook-оос нийт pendingRestoreRef
// хүлээж авна. Хуудас data бэлэн болсны дараа notifyScrollReady дуудахад
// pendingRestoreRef.current() callback ажилна (scroll буцаана).
export const ScrollRestoreProvider = ({ children, onReadyRef }) => {
    const notifyScrollReady = useCallback(() => {
        if (onReadyRef?.current) {
            // Browser paint cycle-г хүлээнэ — DOM-д шинэ элемент бэлэн
            // болсны дараа scroll хийж scroll байршлыг найдвартай болгоно.
            requestAnimationFrame(() => {
                if (onReadyRef?.current) {
                    onReadyRef.current();
                    onReadyRef.current = null;
                }
            });
        }
    }, [onReadyRef]);

    return (
        <ScrollRestoreContext.Provider value={{ notifyScrollReady }}>
            {children}
        </ScrollRestoreContext.Provider>
    );
};
